var map = {
	"./contact.svg": "274d",
	"./content.svg": "88c6",
	"./finance.svg": "862b",
	"./general.svg": "64281",
	"./infrastructure.svg": "1532",
	"./market.svg": "c867",
	"./persons.svg": "6ab8",
	"./template.svg": "c5a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db47";